import { createBehavior } from '@area17/a17-behaviors';
import Swiper, { Navigation } from 'swiper';
// import Swiper styles
import 'swiper/css';

const carousel = createBehavior(
  'carousel',
  {},
  {
    init() {
      const carousel = this;
      this.swiper = new Swiper(this.$node, {
        modules: [Navigation],
        slidesPerView: 1,
        spaceBetween: 16,
        navigation: {
          nextEl: this.getChild('next'),
          prevEl: this.getChild('prev'),
        },
        breakpoints: {
          // md
          768: {
            slidesPerView: 2,
            spaceBetween: 16,
          },
          // lg
          1024: {
            slidesPerView: 3,
            spaceBetween: 16,
          },
        },
      });
      this.swiper.on('slideChange', function () {
        carousel.getChild('index').innerText = (carousel.swiper.activeIndex + 1)
          .toString()
          .padStart(2, '0');
      });
    },
    destroy() {},
  }
);

export default carousel;
